import { Modal, Typography } from "antd"
import { useSelector } from "react-redux"
import { useLocation, useNavigate } from "react-router"

import Icon from "../../Icon"
import { loadInvalidTokenState, saveInvalidTokenState } from "../../Utils/invalidTokenStorage"
import Button from "../Button"
import IntegrationAnimation from "../IntegrationAnimation"

const { Title, Text } = Typography

const StripeTokenInvalidModal = () => {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const isMobile = useSelector((state) => state.nav.isMobile)

  const onClose = () => {
    const state = loadInvalidTokenState()
    saveInvalidTokenState({ ...state, dismissed: true })
    navigate(pathname, { replace: true })
  }

  const handleReconnect = () => {
    window.open("https://marketplace.stripe.com/", "_blank", "noopener,noreferrer")
  }
  return (
    <Modal
      open={true}
      onCancel={onClose}
      footer={null}
      centered={!isMobile}
      closable
      width={442}
      styles={{
        content: {
          borderRadius: 18,
          padding: 28,
          boxShadow: "0 18px 50px rgba(0,0,0,0.22)"
        }
      }}
      classNames={{ content: "clear-bg" }}
    >
      <div style={{ display: "flex", justifyContent: "center", marginTop: 6 }}>
        <IntegrationAnimation icon={<Icon type="connect_stripe" />} />
      </div>

      <div style={{ textAlign: "center", marginTop: 18 }}>
        <Title level={3} style={{ fontSize: 18, marginBottom: 8 }}>
          Stripe connection lost
        </Title>

        <Text type="secondary" style={{ fontSize: 14 }}>
          Your Stripe account is disconnected (Invalid token error)
          <br />
          Please reconnect to continue preventing chargebacks.
        </Text>
      </div>

      <div style={{ marginTop: 24 }}>
        <Button type="primary" size="large" block onClick={handleReconnect}>
          Reconnect Stripe
        </Button>
      </div>
    </Modal>
  )
}

export default StripeTokenInvalidModal
